import { ProgramDetailScreen } from "@/screens";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/programs/$programId")({ 
  component: ProgramDetailScreen,
  loader: async ({ params }) => {
    return {
      crumb: "Detail Program",
      programId: params.programId,
    };
  },
});